import { createFileRoute } from '@tanstack/react-router';
import { PackagePage } from '../screens/company/PackagePage';

/** The company chooses its package on the pricing page itself. */
export const Route = createFileRoute('/t/$tenant/package')({
  component: PackagePage,
});
